import { CameraPlayer } from 'features/cameras/components/CameraPlayer';
import { InlineStatus } from 'components/InlineStatus';
import { useAlertCamera } from 'features/cameras/hooks/useAlertCameras';
import { useParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
    paddingLeft: 'env(safe-area-inset-left)',
    paddingRight: 'env(safe-area-inset-right)',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

export const MobileFullscreenCamera = (): JSX.Element | null => {
  const { classes } = useStyles();
  const { cameraId } = useParams<{ cameraId: string }>();

  const { alertCamera, isLoading, error } = useAlertCamera({
    id: cameraId,
    refetchInterval: 1000 * 15,
  });

  if (isLoading || error) {
    return (
      <InlineStatus
        status={isLoading ? 'loading' : 'error'}
        progressColor="primary"
      />
    );
  }

  return (
    <div className={classes.container}>
      {alertCamera && <CameraPlayer camera={alertCamera} fullScreen />}
    </div>
  );
};
